import { render, staticRenderFns } from "./NsPassword.vue?vue&type=template&id=7ae217aa&scoped=true&"
import script from "./NsPassword.vue?vue&type=script&lang=js&"
export * from "./NsPassword.vue?vue&type=script&lang=js&"
import style0 from "./NsPassword.vue?vue&type=style&index=0&id=7ae217aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae217aa",
  null
  
)

export default component.exports